import type { PartyCompositionGroup } from '@/scopes/products/user-reviews/types'
import { Skeleton } from '@sunwebgroup/uds-ui/skeleton'
import { Tag } from '@sunwebgroup/uds-ui/tag'
import { useIntl } from 'react-intl'
import { useUserReviewsInitialData } from '@/scopes/products/user-reviews/hooks'
import { getPartyCompositionType } from '../utils'
import styles from './MostBookedByLabel.module.css'

export function MostBookedByLabel() {
  const intl = useIntl()
  const { isLoading, partyCompositionGroups } = useUserReviewsInitialData()

  const mostBookedPartyComposition = partyCompositionGroups?.reduce<PartyCompositionGroup | undefined>(
    (prev, current) => {
      return prev && prev.amount > current.amount ? prev : current
    },
    undefined,
  )

  if (isLoading) {
    return <Skeleton className={styles.labelSkeleton} />
  }

  if (!mostBookedPartyComposition) {
    return null
  }

  return (
    <Tag size="M" variant="neutral-tinted">
      {intl.formatMessage(
        { id: 'reviews_most_booked_by_label' },
        {
          partyComposition: intl.formatMessage({
            id: `reviews_party_composition_${getPartyCompositionType(
              mostBookedPartyComposition?.groupId ?? '',
            )}_label`,
          }).toLowerCase(),
        },
      )}
    </Tag>
  )
}
